import { Component, OnInit } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';
import { AnimationItem } from 'lottie-web';

@Component({
  selector: 'vex-unauthorized',
  templateUrl: './inprogress.component.html',
  styleUrls: ['./inprogress.component.scss'],
})
export class InprogressComponent implements OnInit {
  options: AnimationOptions = {
    path: '/assets/lottie/in-progress.json',
  };

  constructor() {}

  ngOnInit(): void {}

  onAnimate(animationItem: AnimationItem): void {
    console.log(animationItem);
  }
}
